export default "__VITE_ASSET__f0f103f4__"